import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { Container, Header, Table } from "semantic-ui-react";
import { BusinessPlanInstructions } from "./Data";
import { withProps } from "recompose";
import DownloadContainer from "./components/DownloadContainer";
import Markdown from "../../components/WrappedMarkdown";

export type RouteParams = null;
export interface OwnProps extends RouteComponentProps<RouteParams> {
	a: string;
}

export interface State {}

const DownloadButtonSection = () => (
	<div>
		<button>Click me to download</button>
	</div>
);

class BusinessPlanPage extends React.Component<OwnProps, State> {
	state = {};

	render() {
		return (
			<Container>
				<Header textAlign="center" size="large">
					About the Small Business Framework
				</Header>
				<p>
					Once you have entered the information relevant for your
					business, you are able to print it off into a Business Plan
					format. The information below provides detailed instructions
					for producing a Business Plan.
				</p>
				<img src={require("./graphic.png")} />
				<Markdown source={BusinessPlanInstructions} />
				<DownloadContainer />
			</Container>
		);
	}
}

export default BusinessPlanPage;



// WEBPACK FOOTER //
// ./src/pages/BusinessPlanPage/BusinessPlanPage.tsx